import React from 'react'
import PropTypes from 'prop-types'
import { StyledButton as Button } from '../common/Button'
import Icon from 'common/components/Icon'
import Menu from '../common/Menu'
import { StyledFormElement as FormElement } from '../common/FormElement'
import MoveMenu from './MoveMenu'
import { ShareButtonContainer } from '../ShareButton/ShareButton'

const ShareButton = ShareButtonContainer(Button)

export const SidebarRowMenu = ({
  innerRef,
  style,
  item,
  canLeave,
  canMove,
  editor,
  rename,
  archvied,
  duplicate,
  remove,
  archive,
  unarchive,
  leave,
  showCantMoveAlert,
  handleClickInside,
  t
}) => {
  return (
    <Menu innerRef={innerRef} style={style} onClick={handleClickInside}>
      {!archvied && (
        <ShareButton item={item}>
          {t('globalNav.share')} {item.type}
        </ShareButton>
      )}
      {editor && <Button onClick={rename}>{t('globalNav.rename')}</Button>}
      {editor && item.type === 'board' && (
        <Button onClick={duplicate}>{t('globalNav.duplicate')}</Button>
      )}
      {editor && (
        <Button onClick={() => remove()}>{t('globalNav.delete')}</Button>
      )}
      {editor && !archvied && (
        <Button onClick={() => archive()}>{t('globalNav.archive')}</Button>
      )}
      {editor && archvied && (
        <Button onClick={() => unarchive()}>{t('globalNav.unarchive')}</Button>
      )}
      {canLeave && (
        <Button onClick={() => leave()}>
          {t('globalNav.leave', { type: item.type })}
        </Button>
      )}
      {editor &&
        !archvied &&
        (canMove ? (
          <MoveMenu item={item}>
            {({ ref, ...props }) => (
              <Button innerRef={ref} {...props}>
                {t('globalNav.move')}
                <FormElement.Spacer />
                <Icon icon="arrowhead-right" />
              </Button>
            )}
          </MoveMenu>
        ) : (
          <Button onClick={showCantMoveAlert}>
            {t('globalNav.move')}
          </Button>
        ))}
    </Menu>
  )
}

SidebarRowMenu.propTypes = {
  item: PropTypes.object.isRequired,
  edit: PropTypes.func.isRequired,
  archive: PropTypes.func.isRequired,
  leave: PropTypes.func.isRequired
}

export default SidebarRowMenu
